(function(){
  function md(){
    var nav=document.querySelector('.menu-drawer__navigation');
    if(nav&&!nav.querySelector('.apl-md-promo')){
      var p=document.createElement('div');p.className='apl-md-promo';
      p.innerHTML='<a href="/collections/mas-vendidos">Los más vendidos<small>Listos para comprar</small></a><a href="/collections/packs-ahorro">Kits de ahorro<small>Hasta −14 %</small></a>';
      nav.insertBefore(p,nav.firstChild);
    }
    var u=document.querySelector('.menu-drawer__utility-links');
    if(u&&!u.querySelector('.apl-md-help')){
      var a=document.createElement('a');a.className='apl-md-help';a.href='https://wa.me/34640389247';a.target='_blank';a.rel='noopener';
      a.innerHTML='<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2c-1.5 0-3-.4-4.3-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8s-.4-.1-.6.1-.7.8-.8 1-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5a1 1 0 0 0-.7.3 3 3 0 0 0-.9 2.2 5.2 5.2 0 0 0 1.1 2.8 11.9 11.9 0 0 0 4.6 4c1.7.7 2.4.8 3.2.7.5-.1 1.5-.6 1.7-1.2s.2-1.1.2-1.2-.2-.2-.5-.3z"/></svg><span>¿Dudas antes de comprar?<small>Escríbenos por WhatsApp · L–V</small></span>';
      u.appendChild(a);
    }
  }
  function init(){md();var d=document.querySelector('menu-drawer, header-drawer');if(d&&window.MutationObserver){new MutationObserver(function(){md()}).observe(d,{childList:true,subtree:true})}}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
})();

/* ACOBET 02-10: regalos desactivados -> nota del pedido neutra */
(function(){
  var P='Indicaciones para la entrega: llamar antes de entregar, el timbre no funciona, dejar en portería, etc.';
  function fix(){document.querySelectorAll('cart-drawer textarea[name="note"]').forEach(function(t){if(t.getAttribute('placeholder')!==P)t.setAttribute('placeholder',P)})}
  var q;function s(){clearTimeout(q);q=setTimeout(fix,80)}
  function init(){fix();if(window.MutationObserver)new MutationObserver(s).observe(document.body,{childList:true,subtree:true})}
  if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init)}else{init()}
})();
